import { defineStore } from 'pinia'
import individualInvestorQuery from '../apollo/queries/pages/individual-investor.gql'

export const useIndividualInvestStore = defineStore('individualInvest', {
  state: () => ({
    data: {}
  }),
  getters: {
    getData: (state) => {
      return state.data.individualInvestor ? state.data.individualInvestor.data.attributes : null
    }
  },
  actions: {
    async requestData() {
      if (Object.keys(this.data).length !== 0) return

      const { data } = await useAsyncQuery(individualInvestorQuery) // eslint-disable-line no-undef

      if (data) this.data = data
    }
  }
})
